import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { Action, createReducer, on } from '@ngrx/store';

import { Feedback } from '@shared/models';

import * as FeedbackActions from './feedback.actions';

export type FeedbackState = EntityState<Feedback>;

export const feedbackAdapter: EntityAdapter<Feedback> = createEntityAdapter<Feedback>({ selectId: (feedback) => feedback.id });

export const initialState: FeedbackState = feedbackAdapter.getInitialState({});

const reducer = createReducer(
  initialState,
  on(FeedbackActions.feedbackLoadSuccess, (state, { feedbackArray }) => feedbackAdapter.upsertMany(feedbackArray, state)),
  on(FeedbackActions.feedbackCreateSuccess, (state, { feedback }) => feedbackAdapter.upsertOne(feedback, state)),
  on(FeedbackActions.feedbackCreateManySuccess, (state, { feedbackArray }) => feedbackAdapter.upsertMany(feedbackArray, state)),
);

export function feedbackReducer(state: FeedbackState | undefined, action: Action) {
  return reducer(state, action);
}
